module.exports = __webpack_public_path__ + "img/daylight_scout.757e919d.gif";